// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_j-0";
export var skeletonCard = "_j-1";